var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9827 7.10896C16.9001 7.02562 16.8017 6.95947 16.6934 6.91433C16.585 6.86919 16.4688 6.84595 16.3514 6.84595C16.234 6.84595 16.1178 6.86919 16.0095 6.91433C15.9011 6.95947 15.8028 7.02562 15.7201 7.10896L9.09594 13.742L6.31289 10.9501C6.22707 10.8672 6.12576 10.802 6.01474 10.7583C5.90373 10.7145 5.78518 10.6931 5.66588 10.6951C5.54657 10.6972 5.42884 10.7227 5.3194 10.7703C5.20997 10.8179 5.11097 10.8865 5.02807 10.9723C4.94516 11.0581 4.87998 11.1595 4.83623 11.2705C4.79248 11.3815 4.77102 11.5 4.77309 11.6193C4.77515 11.7387 4.80069 11.8564 4.84826 11.9658C4.89582 12.0753 4.96447 12.1742 5.0503 12.2572L8.46464 15.6715C8.5473 15.7548 8.64564 15.821 8.75399 15.8661C8.86235 15.9113 8.97856 15.9345 9.09594 15.9345C9.21332 15.9345 9.32954 15.9113 9.43789 15.8661C9.54624 15.821 9.64458 15.7548 9.72724 15.6715L16.9827 8.41601C17.073 8.33275 17.145 8.2317 17.1943 8.11922C17.2435 8.00674 17.269 7.88528 17.269 7.76248C17.269 7.63969 17.2435 7.51823 17.1943 7.40575C17.145 7.29327 17.073 7.19222 16.9827 7.10896Z",
    fill: ""
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.aa0906dbafe45b85fb58eb46808d97fd.svg";
export { ForwardRef as ReactComponent };